import { tryCatch } from '@wix/funnel-utils'
import React, { FC } from 'react'

import { markAsWixStudioAccount } from '../../api/StudioWorkspaceService/markAsWixStudioAccount'
import { FlowId } from '../../flowIds'
import { HeadlessFallback } from '../../Templates'

interface TemplatesFallbackProps {
  flowId: string
}

const handleStudioFallback = async () => {
  await tryCatch(() => markAsWixStudioAccount())
  window.open('https://manage.wix.com/studio/discover', '_self')
}

const FLOW_IDS_WITH_FALLBACK: string[] = [FlowId.HEADLESS, FlowId.NEW_HEADLESS, FlowId.STUDIO]

// Flows without a dedicated fallback should not pass a `fallback` to WixFlow at all:
// rendering this component for them yields a blank page, while no fallback keeps the
// current page interactive so the user can retry after the error notification.
export const hasTemplatesFallback = (flowId: string) => FLOW_IDS_WITH_FALLBACK.includes(flowId)

export const TemplatesFallback: FC<TemplatesFallbackProps> = ({ flowId }) => {
  if (flowId === FlowId.HEADLESS || flowId === FlowId.NEW_HEADLESS) {
    return <HeadlessFallback />
  }
  if (flowId === FlowId.STUDIO) {
    void handleStudioFallback()
  }
  return null
}
